import { useTranslation } from 'react-i18next';

export interface UseInspectionGalleryEmptyLabelParams {
  captureMode: boolean;
  isFilterActive: boolean;
}

export function useInspectionGalleryEmptyLabel({
  captureMode,
  isFilterActive,
}: UseInspectionGalleryEmptyLabelParams): string {
  const { t } = useTranslation();
  if (isFilterActive) {
    return t('inspectionReview.gallery.empty.filter');
  }
  return captureMode
    ? t('inspectionReview.gallery.empty.capture')
    : t('inspectionReview.gallery.empty.nonCapture');
}
